import { render, staticRenderFns } from "./OnboardingAcceptingOrders.vue?vue&type=template&id=35eca1ce"
import script from "./OnboardingAcceptingOrders.vue?vue&type=script&lang=js"
export * from "./OnboardingAcceptingOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports